



































import Component, { mixins } from 'vue-class-component';
import Form from '@/general/abstract/form/mixin/Form';
import DataLoggerFormTemplate from '@/context/data_logger/component/DataLoggerFormTemplate.vue';
import FormBase from '@/general/abstract/form/FormBase.vue';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/context/security/store';
import { LoginFormModel } from '@/context/security/model/LoginFormModel';
import { UserModel } from '@/context/security/model/UserModel';

@Component({
  components: {
    FormBase,
    DataLoggerFormTemplate
  }
})
export default class LoginForm extends mixins<Form<LoginFormModel, LoginFormModel, UserModel>>(Form) {
  model: LoginFormModel = new LoginFormModel('', '');
  vuex!: AuthModule;

  created() {
    this.vuex = getModule(AuthModule, this.$store);
  }

  buildCmd(): LoginFormModel {
    return this.model;
  }

  async submitApi(cmd: LoginFormModel): Promise<UserModel> {
    const user: UserModel = await this.vuex.authenticate(cmd);
    return this.model;
  }

  showRoute(id: number): Record<string, unknown> {
    return {
      name: 'dashboard-show'
    };
  }
}
